export const GreenTickMarkIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="13" cy="12" r="10" fill="#009E82" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.5208 7.3467L11.5208 16.3467L10.4648 16.3216L7.46484 11.3216L8.53671 10.6784L11.0286 14.8316L16.4807 6.65332L17.5208 7.3467Z"
      fill="white"
    />
  </svg>
);
